<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import indexApi from './api/index'
import { checkAndroidAppUpdate } from '@/utils/appUpdate'
function normalizeFileBase(base) {
  const value = base || ""
  return /[?&][^=]*=$/.test(value) ? value : value.replace(/([^/])$/, "$1/")
}
const FRONT_FILE_BASE = normalizeFileBase(process.env.VUE_APP_FRONT_FILE_BASE)
export default {
  created() {
    this.getSystemConfig()
    checkAndroidAppUpdate()
    this.bindViewportHeight()
  },
  beforeDestroy() {
    this.unbindViewportHeight()
  },
  methods: {
    /** 同步 --app-vh：平时用 visualViewport 适配 iOS 底栏；键盘弹起时保持 layout 高度，避免底部按钮被顶上来 */
    bindViewportHeight() {
      this.updateViewportHeight()
      this._viewportHeightHandler = () => this.updateViewportHeight()
      window.addEventListener('resize', this._viewportHeightHandler)
      window.addEventListener('orientationchange', this._viewportHeightHandler)
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', this._viewportHeightHandler)
        window.visualViewport.addEventListener('scroll', this._viewportHeightHandler)
      }
    },
    unbindViewportHeight() {
      if (!this._viewportHeightHandler) return
      window.removeEventListener('resize', this._viewportHeightHandler)
      window.removeEventListener('orientationchange', this._viewportHeightHandler)
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', this._viewportHeightHandler)
        window.visualViewport.removeEventListener('scroll', this._viewportHeightHandler)
      }
      this._viewportHeightHandler = null
    },
    updateViewportHeight() {
      const layoutH = window.innerHeight
      if (!window.visualViewport) {
        document.documentElement.style.setProperty('--app-vh', `${layoutH * 0.01}px`)
        return
      }
      const visualH = window.visualViewport.height
      // 软键盘弹起时 visualViewport 会缩小，若同步缩小页面高度，底部固定按钮会跟着键盘上移
      const keyboardLikelyOpen = layoutH - visualH > 120
      const h = keyboardLikelyOpen ? layoutH : visualH
      document.documentElement.style.setProperty('--app-vh', `${h * 0.01}px`)
    },
    getSystemConfig() {
      indexApi.getConfig().then(res => {
        if (!res.__success) return
        if (res.data) {
          const config = res.data
          // 设置浏览器标题
          if (config.frontSystemName) {
            document.title = config.frontSystemName
          }
          // 设置浏览器图标
          if (config.frontLogo) {
            this.setFavicon(config.frontLogo)
          }
        }
      })
    },
    /**
     * 功能：给图标地址追加缓存标识，避免浏览器继续显示旧favicon。
     * 参数：url 原始图标地址。
     */
    faviconUrlWithCache(url) {
      const joiner = url.indexOf('?') === -1 ? '?' : '&'
      return `${url}${joiner}favicon_v=${Date.now()}`
    },
    /**
     * 功能：获取或创建指定rel的favicon标签。
     * 参数：rel 图标标签rel属性。
     */
    getFaviconLink(rel) {
      let favicon = document.querySelector(`link[rel="${rel}"]`)
      if (!favicon) {
        favicon = document.createElement('link')
        favicon.rel = rel
        document.head.appendChild(favicon)
      }
      return favicon
    },
    setFavicon(logo) {
      // 构建完整的logo URL
      const faviconUrl = this.faviconUrlWithCache(FRONT_FILE_BASE + logo)
      const icon = this.getFaviconLink('icon')
      const shortcutIcon = this.getFaviconLink('shortcut icon')
      icon.href = faviconUrl
      shortcutIcon.href = faviconUrl
    }
  }
}
</script>

<style>
html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    height: calc(var(--app-vh, 1vh) * 100);
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    background-color: #ffffff;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

#app {
    height: 100%;
    height: calc(var(--app-vh, 1vh) * 100);
    overflow: hidden;
    background-color: #ffffff;
}
</style>
